import React, { FC } from 'react';
import { css } from '@emotion/css';
import Spacer from 'evcharging/components/Spacer';

export interface BenefitsItemProps {
  question: string;
  answer: string;
}

const BenefitsItem: FC<BenefitsItemProps> = (props) => {
  const { answer, question } = props;

  return (
    <div>
      <h4 className={styles.answer}>{question}</h4>
      <Spacer value={12} />
      <p className={styles.question}>{answer}</p>
    </div>
  );
};

const styles = {
  answer: css`
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.019em;
    color: #252c32;
  `,
  question: css`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.011em;
    color: #6e7c87;
    padding-bottom: 12px;
  `,
};

export default BenefitsItem;
